import React from "react";
import { LoginHeader } from "../account/loginHeader";
import { PartnerList } from "../main/partnerList";


export const Partner = (props) => {
    return (
        <div className="login">
            
            <LoginHeader></LoginHeader>
            
            <div className="wrap">
                <h2 className="Title mt40">Alege partener</h2>
                <PartnerList ></PartnerList>
            </div>
        </div>
    );
};